
import { FeatureCategory } from './types';

export const commonWords = [
  "system", "feature", "technology", "advanced", "driver",
  "assistance", "safety", "standard", "optional", "installed",
  "available", "package", "with", "and", "the", "a", "an",
  "control", "automatic", "automated", "assist", "warning"
];

export const featureCategories: Record<string, FeatureCategory> = {
  braking: {
    terms: ["brake", "abs", "anti-lock", "emergency brake"],
    importance: 1,
    subCategories: {
      emergency: {
        terms: ["emergency", "automatic emergency", "collision mitigation"],
        importance: 1
      },
      stability: {
        terms: ["stability", "electronic stability", "vehicle stability"],
        importance: 0.9
      }
    }
  },
  blindSpot: {
    terms: ["blind spot", "bsw", "bsm", "side monitoring"],
    importance: 1,
    subCategories: {
      monitoring: {
        terms: ["monitor", "detection", "alert"],
        importance: 0.9
      },
      intervention: {
        terms: ["intervention", "assist", "prevention"],
        importance: 1
      }
    }
  },
  collision: {
    terms: ["collision", "crash", "impact", "pre-collision"],
    importance: 1,
    subCategories: {
      warning: {
        terms: ["warning", "alert", "notification"],
        importance: 0.8
      },
      prevention: {
        terms: ["prevention", "mitigation", "avoidance"],
        importance: 1
      }
    }
  },
  laneDeparture: {
    terms: ["lane", "lka", "ldw", "lane keeping"],
    importance: 1,
    subCategories: {
      warning: {
        terms: ["warning", "alert", "departure warning"],
        importance: 0.8
      },
      assistance: {
        terms: ["assist", "keeping assist", "centering"],
        importance: 1
      }
    }
  },
  pedestrian: {
    terms: ["pedestrian", "ped detection", "vulnerable road user"],
    importance: 1,
    subCategories: {
      detection: {
        terms: ["detection", "recognition", "monitoring"],
        importance: 0.9
      },
      protection: {
        terms: ["protection", "emergency braking", "avoidance"],
        importance: 1
      }
    }
  },
  parking: {
    terms: ["park", "parking", "auto park", "park assist"],
    importance: 0.8,
    subCategories: {
      sensors: {
        terms: ["sensor", "sonar", "detection"],
        importance: 0.7
      },
      camera: {
        terms: ["camera", "view", "display"],
        importance: 0.8
      },
      automation: {
        terms: ["automatic", "self-parking", "autonomous"],
        importance: 1
      }
    }
  },
  backup: {
    terms: ["backup", "rear view", "rear visibility", "back up", "reversing"],
    importance: 1,
    subCategories: {
      camera: {
        terms: ["camera", "system", "monitor"],
        importance: 1
      }
    }
  },
  headlamp: {
    terms: ["headlamp", "headlight", "beam", "light"],
    importance: 0.9,
    subCategories: {
      automatic: {
        terms: ["automatic", "semiautomatic", "switching", "control"],
        importance: 1
      }
    }
  },
  notification: {
    terms: ["notification", "alert", "aacn", "can_aacn", "crash"],
    importance: 1,
    subCategories: {
      automatic: {
        terms: ["automatic", "automated", "system"],
        importance: 0.9
      }
    }
  }
} as const;

export const FUZZY_MATCH_THRESHOLD = 0.85; // Minimum score for fuzzy matching
export const HIERARCHICAL_MATCH_THRESHOLD = 0.75; // Minimum score for hierarchical matching
export const EXACT_MATCH_THRESHOLD = 0.95; // Minimum score for exact matching

export const confidenceLevels = {
  INSTALLED: "Installed",
  NOT_INSTALLED: "Not Installed",
  MAYBE_INSTALLED: "Maybe Installed"
} as const;

export const NHTSA_SAFETY_FIELDS = [
  "ABS",
  "ESC",
  "Traction",
  "BackupCam",
  "ParkAssist",
  "ForwardCollisionWarning",
  "LaneDepartureWarning",
  "LaneKeepSystem",
  "BlindSpotMon",
  "CIB",
  "PedestrianAEB",
  "RearCrossTrafficMonitor",
  "RearVisibilitySystem",
  "SemiautomaticHeadlampBeamSwitching",
  "CAN_AACN",
  "AutoReverseSystem",
  "DynamicBrakeSupport",
  "RearCrossTrafficAlert",
  "RearAutomaticEmergencyBraking",
  "PedestrianAutomaticEmergencyBraking",
  "AdaptiveCruiseControl",
  "AdaptiveHeadlights",
  "BlindSpotIntervention"
] as const;
